const departments = {
    leader: 'ผู้รับผิดชอบ',
    leaders: 'ผู้รับผิดชอบแผนก',
    led_departments: 'แผนกที่คุณดูแล',
    edit_leaders: 'จัดการผู้รับผิดชอบ',
    add_leader: 'เพิ่ม',
    remove_leader: 'นำออก',
    no_leaders: 'ยังไม่มีผู้รับผิดชอบ',
    local: 'จัดการในระบบ',
    managed_members: 'สมาชิกในขอบเขตการจัดการ',
    leader_scope_hint: 'จัดการการสังกัดในแผนกที่คุณดูแลและแผนกย่อย',
    leader_permission_hint: 'ผู้รับผิดชอบจัดการการสังกัดในแผนกและแผนกย่อย โดยไม่เปลี่ยนบทบาทองค์กรหรือโครงสร้างแผนก',
    primary_synced: 'แผนกหลักจัดการโดย Feishu',
    status_active: 'ใช้งานอยู่',
    status_suspended: 'ถูกระงับ',
    status_departed: 'ออกจากองค์กร',
    status_pending: 'รอเปิดใช้งาน',
    search: 'ค้นหา',
    previous_page: 'หน้าก่อนหน้า',
    next_page: 'หน้าถัดไป',
    directory_title: 'สมาชิกองค์กร',
    member_name: 'สมาชิก',
    search_members: 'ค้นหาด้วยชื่อหรือชื่อผู้ใช้',
    include_descendants: 'รวมแผนกย่อย',
    no_members: 'ไม่พบสมาชิกที่ตรงกัน',
    all_members: 'สมาชิกทั้งหมด',
    all_departments: 'แผนกทั้งหมด',
    edit_member: 'แก้ไขแผนก',
    add_child: 'เพิ่มแผนกย่อย',
    expand_department: 'ขยาย {{name}}',
    collapse_department: 'ยุบ {{name}}',
    title: 'แผนก',
    description: 'จัดการแผนกและการสังกัดของสมาชิกในองค์กรนี้',
    create: 'สร้างแผนก',
    edit: 'แก้ไขแผนก',
    name: 'ชื่อแผนก',
    parent: 'แผนกหลักในลำดับชั้น',
    root: 'ไม่มีแผนกเหนือกว่า',
    id: 'รหัสแผนก',
    members: 'แผนกของสมาชิก',
    member_id: 'รหัสผู้ใช้ของสมาชิก',
    primary: 'แผนกหลัก',
    none: 'ยังไม่ตั้งค่า',
    assignments: 'รายการสังกัดแผนก',
    no_assignments: 'ยังไม่มีการสังกัดแผนก',
    assignment_hint: 'กำหนดแผนกภายในและแผนกหลักได้ การสังกัดจากไดเรกทอรีเป็นแบบอ่านอย่างเดียว',
    empty: 'ยังไม่มีแผนก',
    readonly: 'คุณดูแผนกและการสังกัดของตนได้ หากต้องการเปลี่ยนแปลงให้ติดต่อผู้ดูแลองค์กร',
    load_error: 'โหลดข้อมูลไม่ได้ โปรดลองอีกครั้ง',
    mutation_error: 'บันทึกไม่ได้ ตรวจสอบสิทธิ์ สมาชิกภาพ และลำดับชั้นแผนก',
    loading: 'กำลังโหลด…',
    synced: 'จัดการโดยไดเรกทอรี',
    choose: 'ค้นหาแผนก',
    organizations_title: 'องค์กรและแผนก',
    organizations_description: 'เลือกองค์กรเพื่อดูหรือจัดการแผนก',
    no_organizations: 'คุณยังไม่ได้เข้าร่วมองค์กร โปรดติดต่อผู้ดูแล',
    organization: 'องค์กรปัจจุบัน',
    choose_organization: 'เลือกองค์กร',
    delete_title: 'ลบแผนก',
    delete_description: 'ลบ “{{name}}” หรือไม่? โปรดย้ายสมาชิกและแผนกย่อยก่อน',
};
export default Object.freeze(departments);
